import React from "react";
import t from "Utils/translation";
import Button from "Components/button/Button";
import RadioButton from "Components/radiobutton/RadioButton";
import Checkbox from "Components/checkbox/Checkbox";
import Input from "Components/input/Input";
import PasswordGenerator from "Components/PasswordGenerator";
import { deliveryPlans } from "@/config";

const PaymentMethod = ({
  formData,
  setFormFieldValue,
  onFormCancel,
  hasBillingInfo,
  nextStep,
  stepper,
  loggedUser,
}) => {
  const fillPasswordFields = () => {};

  return (
    <div className="flex flex-col items-center h-full p-4 pb-0">
      {stepper}

      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.add.stepPaymentMethod.title")}</div>
        <div className="sectionDesc">{t("delivery.accounts.add.stepPaymentMethod.desc")}</div>
        <Button docsKey="" className="btnDocsFP" color="docs">
          button.docs
        </Button>
      </div>
      <div className="formContainer">
        <div className="flex flex-col w-full">
          {formData.plan !== deliveryPlans.FREE && (
            <div className="mt-9">
              <div className="inputFull2">
                <div className="text-sm font-semibold text-[--text] box-border pb-3">
                  {t("delivery.accounts.add.stepPaymentMethod.payment.title")}
                </div>
              </div>
              <div className="mt-2">
                <RadioButton
                  className="inputFull2"
                  name="payment_method"
                  //eslint-disable-next-line react/no-children-prop
                  children={[
                    {
                      value: "stripe",
                      label: t("radiobtn.label.payment.stripe"),
                      description: t("radiobtn.desc.payment.creditCard"),
                    },
                    {
                      value: "lcwsoftpaypalbillingagreements",
                      label: t("radiobtn.label.payment.lcwsoftpaypalbillingagreements"),
                      description: t("radiobtn.desc.payment.paypal.auto"),
                    },
                    {
                      value: "paypal",
                      label: t("radiobtn.label.payment.paypal"),
                      description: t("radiobtn.desc.payment.paypal"),
                    },
                  ]}
                  value={formData.payment_method}
                  onChange={setFormFieldValue}
                />
              </div>
            </div>
          )}

          {!hasBillingInfo && (
            <>
              <div className="mt-9">
                <div className="text-sm font-semibold text-[--text] box-border pb-3">
                  {t("delivery.accounts.add.stepPaymentMethod.credentials.title")}
                </div>
                <div className="sectionDesc">{t("delivery.accounts.add.stepPaymentMethod.credentials.desc")}</div>
                <div className="mt-2">
                  <div className="text-sm">
                    {t("label.username")}:{" "}
                    <span className="px-2 ml-2 bg-gray-100 rounded">{loggedUser.email_address}</span>
                  </div>
                  <div className="mt-2 text-sm">
                    {t("label.password")}:{" "}
                    <span className="px-2 ml-2 bg-gray-100 rounded">{t("delivery.accounts.add.stepPaymentMethod.customerAreaCredentials.password")}</span>
                  </div>
                </div>

                <div className="mt-7">
                  <Checkbox
                    name="customer_area_credentials"
                    label={t("delivery.accounts.add.stepPaymentMethod.customerAreaCredentials.label")}
                    value={formData.customer_area_credentials}
                    onChange={setFormFieldValue}
                  />
                  {formData.customer_area_credentials && (
                    <>
                      <Input
                        className="mt-3"
                        name="customer_area_email"
                        label={t("input.label.customerAreaEmail")}
                        placeholder={t("input.placeholder.email")}
                        value={formData.customer_area_email}
                        onChange={setFormFieldValue}
                      />
                      <Input
                        className="mt-7"
                        name="customer_area_password"
                        label={t("input.label.customerAreaPassword")}
                        placeholder={t("input.placeholder.pwdRules")}
                        value={formData.customer_area_password}
                        onChange={setFormFieldValue}
                      />
                      <Input
                        className="mt-3"
                        name="customer_area_password_confirm"
                        label={t("input.label.customerAreaPassword.confirm")}
                        placeholder={t("input.placeholder.pwdRules")}
                        value={formData.customer_area_password_confirm}
                        onChange={setFormFieldValue}
                      />

                      <PasswordGenerator onNewPassword={fillPasswordFields} />
                    </>
                  )}
                </div>
              </div>
              <div className="mt-9">
                <div className="text-sm font-semibold text-[--text] box-border pb-3">
                  {t("delivery.accounts.add.stepPaymentMethod.additionalBilling.title")}
                </div>
                <div className="mt-2">
                  <Input
                    name="additional_billing_firstname"
                    label={t("input.label.firstName")}
                    placeholder={t("input.placeholder.firstName")}
                    value={formData.additional_billing_firstname}
                    onChange={setFormFieldValue}
                  />
                  <Input
                    className="mt-3"
                    name="additional_billing_lastname"
                    label={t("input.label.lastName")}
                    placeholder={t("input.placeholder.lastName")}
                    value={formData.additional_billing_lastname}
                    onChange={setFormFieldValue}
                  />
                  <Input
                    className="mt-3"
                    name="additional_billing_email"
                    label={t("input.label.email")}
                    placeholder={t("input.placeholder.email")}
                    value={formData.additional_billing_email}
                    onChange={setFormFieldValue}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div className="flexColumnContainer">
          <div className="formFooter">
            <Button color="text" type="button" onClick={onFormCancel}>
              button.cancel
            </Button>
            <Button color="accent" onClick={nextStep}>
              button.continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
